import firebase from 'firebase/app';
import 'firebase/firestore';

// Init Firebase
const config = {
  apiKey: 'AIzaSyA8NR7mR2nC3Hm4gw_weQME_rZuyIsx4ck',
  authDomain: 'memoriesforyiqing.firebaseapp.com',
  databaseURL: 'https://memoriesforyiqing.firebaseio.com',
  projectId: 'memoriesforyiqing',
  storageBucket: 'memoriesforyiqing.appspot.com',
  messagingSenderId: '886910150409',
  appId: '1:886910150409:web:3234f8ec766e27e82095d8',
};
firebase.initializeApp(config);

// Firestore
const db = firebase.firestore();

// References
const postsCollection = db.collection('posts');

export {
  db,
  postsCollection,
};
